/* Quem está no topo agora.
 *
 * A `Folha` é um `<dialog>` modal: o navegador a põe na camada superior, e no
 * WebKit — que é o navegador deste app — **nada** se sobrepõe a um diálogo
 * modal, nem um `popover` aberto depois dele. Medido no WebKit do Playwright
 * (Safari 26): com o diálogo aberto, o ponto do toque sobre um popover no
 * rodapé devolve o diálogo, tenha o popover sido aberto antes, depois ou
 * reaberto.
 *
 * Daí este registro. O `Toast` precisa falar por cima da folha — é dentro
 * dela que o salvamento falha — e o único lugar de onde isso é possível é
 * dentro do próprio diálogo. A folha aberta se anuncia aqui; o `Toast` mantém
 * uma região viva no `body` e outra dentro da folha do topo, e escreve na que
 * estiver ativa. O que este registro diz, portanto, é **onde escrever**, não
 * quais nós existem: mudar o destino de um portal recria o nó, e uma região
 * viva recriada com texto dentro é muda (ver `Toast.tsx`).
 *
 * Uma pilha, não um só: duas folhas empilhadas devolvem a de baixo quando a de
 * cima fecha, e o aviso acompanha. */

type Ouvinte = () => void;

const pilha: HTMLElement[] = [];
const ouvintes = new Set<Ouvinte>();

function avisar(): void {
  for (const ouvinte of ouvintes) ouvinte();
}

/** Empilha o elemento como topo enquanto ele estiver aberto. Devolve a função
 *  que o desempilha — chamá-la duas vezes não faz mal. */
export function empilharNoTopo(elemento: HTMLElement): () => void {
  pilha.push(elemento);
  avisar();
  let soltou = false;
  return () => {
    if (soltou) return;
    soltou = true;
    const onde = pilha.lastIndexOf(elemento);
    if (onde !== -1) pilha.splice(onde, 1);
    avisar();
  };
}

/** O elemento no topo, ou `null` quando não há nenhum. Referência estável
 *  enquanto nada muda, que é o que `useSyncExternalStore` exige. */
export function topo(): HTMLElement | null {
  return pilha.length === 0 ? null : (pilha[pilha.length - 1] ?? null);
}

export function assinarTopo(ouvinte: Ouvinte): () => void {
  ouvintes.add(ouvinte);
  return () => {
    ouvintes.delete(ouvinte);
  };
}
